import React, { useState, useEffect } from 'react';
import MainLayout from '../components/MainLayout';
import {
  Paper,
  Typography,
  Box,
  Card,
  CardContent,
  CircularProgress,
  Stack,
} from '@mui/material';
import {
  People as PeopleIcon,
  VideoLibrary as VideoIcon,
  Link as LinkIcon,
  Visibility as VisibilityIcon,
  Share as ShareIcon,
} from '@mui/icons-material';
import { reportsAPI } from '../services/api';

interface DashboardStats {
  totalPeople: number;
  totalVideos: number;
  totalLinks: number;
  totalViews: number;
  sharedLinks: number;
}

const Dashboard = () => {
  const [stats, setStats] = useState<DashboardStats>({
    totalPeople: 0,
    totalVideos: 0,
    totalLinks: 0,
    totalViews: 0,
    sharedLinks: 0,
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchStats = async () => {
      try {
        const response = await reportsAPI.getSummary();
        setStats(response.data.summary);
      } catch (error) {
        console.error('İstatistikler alınırken hata:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchStats();
  }, []);

  if (loading) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" height="60vh">
        <CircularProgress />
      </Box>
    );
  }

  return (
    <>
      <Typography variant="h4" component="h1" gutterBottom>
        Ana Sayfa
      </Typography>
      <Typography variant="body1" color="text.secondary" paragraph>
        Video dağıtım ve ilgi takip sistemine hoş geldiniz.
      </Typography>

      <Box sx={{ mt: 2 }}>
        <Stack
          direction={{ xs: 'column', sm: 'row' }}
          spacing={{ xs: 1, sm: 2, md: 3 }}
          useFlexGap
          flexWrap="wrap"
        >
          <Box sx={{ minWidth: { xs: '100%', sm: '48%', md: '23%' } }}>
            <Card>
              <CardContent>
                <Box display="flex" alignItems="center">
                  <PeopleIcon color="primary" sx={{ fontSize: 40, mr: 2 }} />
                  <Box>
                    <Typography variant="h4" component="div">
                      {stats.totalPeople}
                    </Typography>
                    <Typography color="text.secondary">
                      Toplam Kişi
                    </Typography>
                  </Box>
                </Box>
              </CardContent>
            </Card>
          </Box>

          <Box sx={{ minWidth: { xs: '100%', sm: '48%', md: '23%' } }}>
            <Card>
              <CardContent>
                <Box display="flex" alignItems="center">
                  <VideoIcon color="primary" sx={{ fontSize: 40, mr: 2 }} />
                  <Box>
                    <Typography variant="h4" component="div">
                      {stats.totalVideos}
                    </Typography>
                    <Typography color="text.secondary">
                      Toplam Video
                    </Typography>
                  </Box>
                </Box>
              </CardContent>
            </Card>
          </Box>

          <Box sx={{ minWidth: { xs: '100%', sm: '48%', md: '23%' } }}>
            <Card>
              <CardContent>
                <Box display="flex" alignItems="center">
                  <LinkIcon color="primary" sx={{ fontSize: 40, mr: 2 }} />
                  <Box>
                    <Typography variant="h4" component="div">
                      {stats.totalLinks}
                    </Typography>
                    <Typography color="text.secondary">
                      Oluşturulan Link
                    </Typography>
                  </Box>
                </Box>
              </CardContent>
            </Card>
          </Box>

          <Box sx={{ minWidth: { xs: '100%', sm: '48%', md: '23%' } }}>
            <Card>
              <CardContent>
                <Box display="flex" alignItems="center">
                  <VisibilityIcon color="primary" sx={{ fontSize: 40, mr: 2 }} />
                  <Box>
                    <Typography variant="h4" component="div">
                      {stats.totalViews}
                    </Typography>
                    <Typography color="text.secondary">
                      Toplam İzlenme
                    </Typography>
                  </Box>
                </Box>
              </CardContent>
            </Card>
          </Box>
        </Stack>
      </Box>

      <Box sx={{ mt: 3 }}>
        <Stack
          direction={{ xs: 'column', md: 'row' }}
          spacing={{ xs: 2, md: 3 }}
        >
          <Box sx={{ width: { xs: '100%', md: '50%' } }}>
            <Paper sx={{ p: 3, height: '100%' }}>
              <Typography variant="h6" gutterBottom>
                Hızlı İşlemler
              </Typography>
              <Typography variant="body2" color="text.secondary" paragraph>
                Sol menüden hızlıca kişi, video veya link ekleyebilirsiniz.
              </Typography>
            </Paper>
          </Box>

          <Box sx={{ width: { xs: '100%', md: '50%' } }}>
            <Paper sx={{ p: 3, height: '100%' }}>
              <Box display="flex" alignItems="center">
                <ShareIcon color="warning" sx={{ fontSize: 40, mr: 2 }} />
                <Box>
                  <Typography variant="h5">
                    {stats.sharedLinks}
                  </Typography>
                  <Typography color="text.secondary">
                    Şüpheli/Paylaşılmış Link
                  </Typography>
                </Box>
              </Box>
              <Typography variant="body2" color="text.secondary" sx={{ mt: 2 }}>
                Paylaşım tespiti için Raporlar sayfasını kontrol edin.
              </Typography>
            </Paper>
          </Box>
        </Stack>
      </Box>
    </>
  );
};

export default Dashboard;